import resetPwd from './resetPwd';
export default {
    resetPwd,
};



// WEBPACK FOOTER //
// ./src/api/userCenter/index.ts